export default "__VITE_ASSET__1d7af69c__"